var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2081 6.87504L17.4164 3.66671M19.2498 1.83337L17.4164 3.66671L19.2498 1.83337ZM10.4406 10.6425C10.9139 11.1096 11.2902 11.6656 11.5477 12.2786C11.8052 12.8916 11.939 13.5495 11.9412 14.2145C11.9434 14.8794 11.8141 15.5382 11.5607 16.1529C11.3073 16.7676 10.9347 17.3262 10.4646 17.7963C9.99439 18.2665 9.43586 18.639 8.82112 18.8925C8.20639 19.1459 7.5476 19.2752 6.88268 19.273C6.21776 19.2708 5.55984 19.137 4.94682 18.8795C4.3338 18.6219 3.77777 18.2457 3.31076 17.7724C2.39238 16.8215 1.88421 15.548 1.8957 14.2261C1.90719 12.9042 2.43741 11.6396 3.37218 10.7049C4.30694 9.77011 5.57146 9.23988 6.89337 9.22839C8.21527 9.21691 9.48881 9.72508 10.4397 10.6435L10.4406 10.6425ZM10.4406 10.6425L14.2081 6.87504L10.4406 10.6425ZM14.2081 6.87504L16.9581 9.62504L20.1664 6.41671L17.4164 3.66671L14.2081 6.87504Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeyIcon);
export default __webpack_public_path__ + "static/media/keyIcon.828e02afc675317ed7f8bafc06bc1a43.svg";
export { ForwardRef as ReactComponent };